import React from 'react';
import styled from 'styled-components/macro';
import {
  sizesMap,
  textLineHeight,
  textLetterSpacing,
  typographyMarginBottom,
} from '../utils';

export const Circle = styled.span<{ color?: string }>`
  background-color: ${(p) => p.color ?? p.theme.colors.secondary};
  height: 10px;
  width: 10px;
  min-width: 10px;
  margin-right: 10px;
  border-radius: 10px;
`;

export const StatusWrapper = styled.label<{ margin?: 'none' }>`
  display: inline-flex;
  align-items: center;
  font-family: ${(p) => p.theme.fonts.gtEesti};
  color: ${(p) => p.theme.colors.black};
  white-space: nowrap;
  font-size: ${sizesMap.sm.size};
  line-height: ${textLineHeight};
  letter-spacing: ${textLetterSpacing};
  text-transform: uppercase;
  margin: ${(p) => typographyMarginBottom(p.margin === 'none')};
`;

type StatusProps = {
  status: string;
  color?: string;
  margin?: 'none';
  style?: React.CSSProperties;
};
function GenericStatus(props: StatusProps) {
  const { status, color, margin, style } = props;

  return (
    <StatusWrapper margin={margin} style={style}>
      <Circle color={color} />
      {status}
    </StatusWrapper>
  );
}

export default React.memo(GenericStatus);
